import _ from 'lodash';

import history from 'config/history';

import {parseGetParams, getUrlQuery, updateCurrentUrlParams} from 'utils/urls';

export const MODAL_KEY_PREFIX = 'm';
export const MODAL_NAME_KEY = `${MODAL_KEY_PREFIX}Name`;

export const parseModalData = modalParams => {
  const result = {};

  Object.keys(modalParams).forEach(param => {
    if (param.startsWith(MODAL_KEY_PREFIX) && param !== MODAL_NAME_KEY) {
      result[_.camelCase(param.substring(MODAL_KEY_PREFIX.length))] =
        modalParams[param];
    }
  });

  return result;
};

export const getModalParams = query => {
  const params = parseGetParams(query);
  const modalParams = {};

  Object.keys(params).forEach(key => {
    if (key.startsWith(MODAL_KEY_PREFIX)) {
      modalParams[key] = params[key];
    }
  });

  return modalParams;
};

export const openModalFromUrl = (modals, openModal) => {
  const modalParams = getModalParams(history.location.search);
  const modalName = modalParams[MODAL_NAME_KEY];

  if (!modalName) {
    return;
  }

  if (_.includes(Object.values(modals), modalName)) {
    openModal(modalName, parseModalData(modalParams));
  }
};

export const storeModalInUrl = modalParams => {
  let modalQueryParams = {};

  Object.keys(modalParams).forEach(param => {
    // Adding an _ (underscore) between the prefix and the param name
    // So we can safely transform this into camel case.
    // For example: `m_someId` will be transformed into `mSomeId`
    const key = _.camelCase(`${MODAL_KEY_PREFIX}_${param}`);
    const value = encodeURIComponent(modalParams[param]);

    modalQueryParams[key] = value;
  });

  updateCurrentUrlParams(modalQueryParams);
};

export const removeModalFromUrl = modalData => {
  const getParams = parseGetParams(getUrlQuery());
  // Make a list of all modal parameters that would be found in the url
  const modalKeysForUrl = Object.keys(modalData).map(key =>
    _.camelCase(`${MODAL_KEY_PREFIX}_${key}`)
  );

  // If the get params do not contain the modal name - don't remove anything.
  // This keeps modals that *are not* saved in the url from
  // removing data of modals that *are* saved in the url
  const modalNameForUrl = _.camelCase(`${MODAL_KEY_PREFIX}_Name`);
  if (_.get(getParams, modalNameForUrl, false) !== modalData.name) {
    return;
  }

  const nonModalParams = _.mapValues(getParams, (value, key) => {
    // If it is a modal param - set it to null so it can be removed
    if (_.find(modalKeysForUrl, modalKey => modalKey === key)) {
      return null;
    }
    // else leave it so it won't be erased from the url
    return value;
  });

  updateCurrentUrlParams(nonModalParams);
};
